import { createAsyncThunk } from "@reduxjs/toolkit";
import Hexapi from "../../utility/HexAPI/Hexapi";

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async ({usercodeset,autologin}, thunkAPI) => {
    const obj={
  query:`HRApp_WebMaster_Proc_User_Login @usercode = '{0}',@clientdetails = '{1}',@autologin ='{2}'`,
  queryArr:[`${usercodeset}`,`${navigator.userAgent}`,`${autologin}`],
  dbname:"HRApp_OrgDb_Hex"
}
    const res = await Hexapi(obj)
    return res;
  }
);
